/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-structured".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_STRUCTURED: NodeDef = {
  "id": "x-structured",
  "tagKey": "path:x-structured.tag",
  "x": 936,
  "y": 440,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-structured.title",
  "subKey": "path:x-structured.sub",
  "blocks": [
    {
      "id": "x-structured.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-structured.b1.title",
      "bodyKey": "path:x-structured.b1.body",
      "flowKey": "path:x-structured.b1.flow",
      "read": [
        "guided"
      ]
    },
    {
      "id": "x-structured.b2",
      "kind": "math",
      "xp": 25,
      "titleKey": "path:x-structured.b2.title",
      "math": {
        "exprKey": "path:x-structured.b2.math.expr",
        "readKey": "path:x-structured.b2.math.read",
        "useKey": "path:x-structured.b2.math.use",
        "ref": "guided"
      }
    },
    {
      "id": "x-structured.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-structured.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-structured.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-structured.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-structured.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-structured.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-structured.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-structured.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-structured.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-structured.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "guardrails"
};